export default {
  type: 'object',
  properties: {
    0: {
      description: 'The unique identifier this FB App',
      type: 'string'
    }
  },
  required: ['0']
};